import { FormEvent, useLayoutEffect, useState } from "react";

import { SubProductAction } from "features/product/types/actions.subproduct";
import SubmitButton from "features/shared/components/form/components/submitButton";
import ModalHeader from "features/shared/components/modals/modalHeader";
import Modal from "features/shared/components/modal";

import { useDispatch, useSelector } from "services/redux/rootReducer";
import LabelWrapper from "features/shared/components/form/components/labelWrapper";
import {
    Container,
    FormContainer,
    ModalContainer,
} from "./promotionTagUploadModal.styled";
import useCurrentTableState from "../../hooks/useCurrentTableState";
import { IPromotionTagUploadModal } from "features/product/types/modals";
import BasicInput from "features/shared/components/form/components/basicInput";

interface Props {
    onCloseHandler: () => void;
}

const PromotionTagUploadModal: React.FC<
    Props & IPromotionTagUploadModal["params"]
> = ({ onCloseHandler, subProductId, propertyAccessor }) => {
    const [promotionTag, setPromotionTag] = useState<string>("");

    const dispatch = useDispatch();
    const { readOnlyMode } = useSelector((state) => state.subProducts);

    const { subProducts } = useCurrentTableState();

    useLayoutEffect(() => {
        setPromotionTag(
            subProducts[subProductId].properties[propertyAccessor]
                .value as string
        );
    }, [propertyAccessor, subProductId, subProducts]);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch({
            type: SubProductAction.SET_SUBPRODUCT_PROPERTY_VALUE,
            subProductId,
            accessor: propertyAccessor,
            propertyValue: promotionTag,
        });

        onCloseHandler();
    };
    return (
        <Modal
            id="subProductPromotionTagUpload"
            onCloseHandler={onCloseHandler}
        >
            <ModalContainer>
                <ModalHeader
                    onCloseHandler={onCloseHandler}
                    headingText="Set Promotion Tag"
                />
                <Container>
                    <FormContainer onSubmit={handleSubmit}>
                        <LabelWrapper label="Tag Text">
                            <BasicInput
                                value={promotionTag}
                                name="promotionTag"
                                onChangeHandler={(e) =>
                                    setPromotionTag(e.target.value)
                                }
                            />
                        </LabelWrapper>
                        {!readOnlyMode && <SubmitButton text="Set Tag" />}
                    </FormContainer>
                </Container>
            </ModalContainer>
        </Modal>
    );
};

export default PromotionTagUploadModal;
